import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    Grid,
    Card,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Button,
    styled,
    CardMedia 
} from '@mui/material';
import Footer from '../navbar/Footer';
import moment from 'moment'; 

const StyledTitle = styled(Typography)(({ theme }) => ({
    color: 'green',
    marginBottom: theme.spacing(1),
}));

const StyledDescription = styled(Typography)(({ theme }) => ({
    textAlign: 'left',
    marginBottom: theme.spacing(2),
    color: '#555',
}));

const annuairesData = [
        {
        title: "Indicateurs du développement humain durable édition 2024",
        link: "/documents/indicateursDHD/DHD_2024_version_du_25_Fevrier_2026.pdf",
        description: "Dans l'édition 2024, nous analysons approfondement des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2024-12-15",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
       {
        title: "Indicateurs du développement humain durable édition 2023",
        link: "/documents/indicateursDHD/DHD_2023_version_finale.pdf",
        description: "Dans l'édition 2023, nous analysons approfondement des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2023-12-15",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
    {
        title: "Indicateurs du développement humain durable édition 2022",
        link: "/documents/indicateursDHD/Document-DHD_2022.pdf",
        description: "Dans l'édition 2022, nous analysons approfondement des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2022-12-15",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
    {
        title: "Indicateurs du développement humain durable édition 2021",
        link: "/documents/indicateursDHD/Document-des-indicateurs-du-Developpement-Humain-Durable-2021.pdf",
        description: "L'analyse  des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2021-11-20",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
    {
        title: "Indicateurs du développement humain durable édition 2020",
        link: "/documents/indicateursDHD/Document-des-indicateurs-du-Developpement-Humain-Durable-final_2020_final-Copie.pdf",
        description: "L' analyse des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2020-05-10",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
    {
        title: "Indicateurs du développement humain durable édition 2019",
        link: "/documents/indicateursDHD/Document-des-indicateurs-du-Developpement-Humain-Durable_Version-final-de-2019.pdf",
        description: "L'analyse des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2019-03-25",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
    {
        title: "Indicateurs du développement humain durable édition 2018",
        link: "/documents/indicateursDHD/DHD_2018.pdf",
        description: "L'analyse des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2018-01-10",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
    {
        title: "Indicateurs du développement humain durable édition 2017",
        link: "/documents/indicateursDHD/Indicateurs-dhd-2017.pdf",
        description: "L'analyse des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2017-02-28",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
    {
        title: "Indicateurs du développement humain durable édition 2016",
        link: "/documents/indicateursDHD/DHD_2016.pdf",
        description: "L'analyse des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2016-07-15",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
    {
        title: "Indicateurs du développement humain durable édition 2015",
        link: "/documents/indicateursDHD/DHD-2015.pdf",
        description: "L'analyse des dimensions clés telles que : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».",
        publicationDate: "2015-09-01",
        image: 'assets/indicateursDHD/cover.PNG', 
    },
];

const ITEMS_PER_PAGE = 2;

function IndicateurDHD() {
    const [filterYear, setFilterYear] = useState('all');
    const [page, setPage] = useState(0);

    const handleFilterChange = (event) => {
        setFilterYear(event.target.value);
        setPage(0); 
    };

    const getYear = (dateString) => {
        return new Date(dateString).getFullYear();
    };

    const filteredData = filterYear === 'all'
        ? annuairesData
        : annuairesData.filter(item => getYear(item.publicationDate) === parseInt(filterYear));

    const years = [...new Set(annuairesData.map(item => getYear(item.publicationDate)))];
    years.sort((a, b) => b - a);

    const handleLoadMore = () => {
        setPage(prevPage => prevPage + 1);
    };

    const displayedData = filteredData.slice(0, (page + 1) * ITEMS_PER_PAGE);
    const hasMore = displayedData.length < filteredData.length; 

    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
            <NavigationBar />
            <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
                <StyledTitle variant="h4" align="justify" paragraph>
                    Indicateurs de Développement Humain Durable(DHD)
                </StyledTitle>

                <StyledDescription variant="body1" align="justify" paragraph>
                     Cette section présente les Indicateurs de Développement Humain Durable (DHD) au Burundi, une base de données essentielle pour les chercheurs et les acteurs du développement. L'objectif principal de cette base est de fournir des indicateurs de développement réguliers et fiables, qui permettront d'élaborer des stratégies et programmes socio-économiques à la fois adaptés, durables et réalisables. Elle regroupe des données chiffrées diversifiées, organisées en neuf modules clés : « Population, habitat et emploi » ; « Enseignement et alphabétisation » ; « Santé et nutrition » ; « Aide extérieure » ; « Environnement » ; « Macroéconomie » ; « Communication » ; « Dépenses militaires » ; et « Pauvreté ».
                </StyledDescription>

                <FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px' }}>
                    <InputLabel id="year-filter-label">Sélectionnez par l'année de publication</InputLabel>
                    <Select
                        labelId="year-filter-label"
                        id="year-filter"
                        value={filterYear}
                        label="Sélectionnez par l'année de publication"
                        onChange={handleFilterChange}
                    >
                        <MenuItem value="all">Tous les indicateurs (DHD)</MenuItem>
                        {years.map(year => (
                            <MenuItem key={year} value={year}>{year}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Grid container spacing={1} style={{ marginTop: '10px' }}>
                    {displayedData.map((indice, index) => (
                        <Grid item xs={12} sm={12} key={index}>
                            <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                <Box sx={{ display: 'flex' }}>
                                    <a
                                        href={indice.link}
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 151, height: 200, m: 2 }}
                                            image={indice.image}
                                            alt={indice.title}
                                        />
                                    </a>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                                        <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                                            <a
                                                href={indice.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ textDecoration: 'none', color: 'green' }} 
                                            >
                                                {<DownloadIcon />}{indice.title}
                                            </a>
                                        </Typography>
                                        <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                                            {indice.description}
                                        </Typography>
                                        <Typography variant="caption" color="textSecondary">
                                            Publié en {moment(indice.publicationDate).format('MMMM YYYY')}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                {hasMore && (
                    <Box textAlign="left" mt={2}>
                        <Button variant="contained" color="success" onClick={handleLoadMore}>
                            Plus de rapports
                        </Button>
                    </Box>
                )}
            </Container>
            <br />
            <br />
            <Footer />
        </div>
    );
}

export default IndicateurDHD;